import { call, put } from "redux-saga/effects";
import {
  getMainSalesPlan,
  createMainSalesPlan,
  updateMainSalesPlan,
  deleteMainSalesPlan,
  createSalesPlan,
  deleteSalesPlan,
  getSalesPlan,
  updateSalesPlan,
} from "../../../../Services/apiService";

import {
  getMainSalesPlanFailure,
  getMainSalesPlanSuccess,
  createMainSalesPlanFailure,
  createMainSalesPlanSuccess,
  updateMainSalesPlanFailure,
  updateMainSalesPlanSuccess,
  deleteMainSalesPlanFailure,
  deleteMainSalesPlanSuccess,
  createSalesPlanFailure,
  createSalesPlanSuccess,
  deleteSalesPlanFailure,
  deleteSalesPlanSuccess,
  getSalesPlanFailure,
  getSalesPlanSuccess,
  updateSalesPlanFailure,
  updateSalesPlanSuccess,
} from "../../../Slices/salesPlanSlice";

export function* getMainSalesPlanHandler(actions) {
  try {
    const response = yield call(getMainSalesPlan, actions?.payload);
    yield put(getMainSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(getMainSalesPlanFailure(errResponse));
  }
}

export function* createMainSalesPlanHandler(actions) {
  try {
    const response = yield call(createMainSalesPlan, actions?.payload);
    yield put(createMainSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(createMainSalesPlanFailure(errResponse));
  }
}

export function* updateMainSalesPlanHandler(actions) {
  try {
    const response = yield call(updateMainSalesPlan, actions?.payload);
    yield put(updateMainSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(updateMainSalesPlanFailure(errResponse));
  }
}

export function* deleteMainSalesPlanHandler(actions) {
  try {
    const response = yield call(deleteMainSalesPlan, actions?.payload);
    yield put(deleteMainSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(deleteMainSalesPlanFailure(errResponse));
  }
}

export function* getSalesPlanHandler(actions) {
  try {
    const response = yield call(getSalesPlan, actions?.payload);
    yield put(getSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(getSalesPlanFailure(errResponse));
  }
}

export function* createSalesPlanHandler(actions) {
  try {
    const response = yield call(createSalesPlan, actions?.payload);
    yield put(createSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(createSalesPlanFailure(errResponse));
  }
}

export function* updateSalesPlanHandler(actions) {
  try {
    const response = yield call(updateSalesPlan, actions?.payload);
    yield put(updateSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(updateSalesPlanFailure(errResponse));
  }
}

export function* deleteSalesPlanHandler(actions) {
  try {
    const response = yield call(deleteSalesPlan, actions?.payload);
    yield put(deleteSalesPlanSuccess(response?.data));
  } catch (err) {
    const errResponse = err?.response?.data?.message;
    yield put(deleteSalesPlanFailure(errResponse));
  }
}
